import { EngagementBuyer } from '../../../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceOpportunityStatus } from '../../../slices/marketplace/opportunity/models/opportunity-status';

/**
 * True when every available (active) buyer is already selected (Engaged) for the
 * given selection action — there is nothing left to decide, so "Finalize selection"
 * skips its confirmation popup. Zero active buyers is not "all selected".
 * Mirrors Timeline.IsBuyerSelectionComplete on the backend — keep the two in sync.
 */
export const areAllAvailableBuyersSelected = (
    buyers: EngagementBuyer[] | undefined,
    actionId: number | undefined
): boolean => {
    if (actionId == null) {
        return false;
    }
    const activeBuyers = buyers?.filter((buyer) => buyer.isActive) ?? [];
    return (
        activeBuyers.length > 0 &&
        activeBuyers.every((buyer) =>
            buyer.actionState?.some(
                (state) =>
                    state.actionId === actionId &&
                    state.buyerStatus === MarketplaceOpportunityStatus.Engaged
            )
        )
    );
};
